import {DeviceService} from "./Services/DeviceService";
import {environment} from '../Environments/environment';
import {RequestSenderProvider} from "../Cirrus/tlDataServices/tlDataServices.module";
import {defaultRoute, routing} from "./app.routing";
import {NotificationService} from "./Services/NotificationService";
import {EntryQueueService} from "./Services/EntryQueueService";
import {TimeEntryDataService} from "./Services/TimeEntryDataService";
import {LoginController} from "./Components/login/login";
import {DebugController} from "./Components/debug/debug";
import {ScannerService} from "./Services/ScannerService";
import {AppController} from "./Components/app/app";
import {StorageService} from "./Services/StorageService";
import {SettingsController} from "./Components/settings/settings";
import {VersionService} from "./Services/VersionService";
import {AuthenticationService} from "./Services/AuthenticationService";
import {CordovaService} from "./Services/CordovaService";
import {TerminalHomeController} from "./Components/terminal-home/terminal-home";
import {PersonHomeController} from "./Components/person-home/person-home";
import {NavigationService} from "./Services/NavigationService";
import {ExpenseListController} from "./Components/expense-list/expense-list";
import {ExpenseDetailController} from "./Components/expense-detail/expense-detail";
import {AbsenceListController} from "./Components/absence-list/absence-list";
import {BookingListController} from "./Components/booking-list/booking-list";
import {BookingDetailController} from "./Components/booking-detail/booking-detail";
import {AbsenceDetailController} from "./Components/absence-detail/absence-detail";
import {DialogDirective} from "./Directives/dialog/dialog";
import {EnterController} from './Components/enter/enter';
import {StartController} from './Components/start/start';
import {TimeEntryDialogDirective} from "./Directives/time-entry-dialog/time-entry-dialog";
import {CameraService} from "./Services/CameraService";
import {BookingDataService} from "./Services/BookingDataService";
import {AbsenceDataService} from "./Services/AbsenceDataService";
import {ExpenseDataService} from "./Services/ExpenseDataService";
import {TerminalSessionService} from "./Services/TerminalSessionService";
import {ClockDirective} from "./Directives/clock/clock";
import {SaveDialogDirective} from "./Directives/save-dialog/save-dialog";
import {DeleteDialogDirective} from "./Directives/delete-dialog/delete-dialog";
import {ConfirmDialogDirective} from "./Directives/confirm-dialog/confirm-dialog";
import {WaitDialogDirective} from "./Directives/wait-dialog/wait-dialog";
import {EmployeeDataService} from './Services/EmployeeDataService';
import {UserService} from "./Services/UserService";
import {SettingsDialogDirective} from './Directives/settings-dialog/settings-dialog';
import {LogoutService} from "./Services/LogoutService";
import {ExpenseTypeDialogDirective} from "./Directives/expense-type-dialog/expense-type-dialog-directive";
import {PwaInstallService} from "./Services/PwaInstallService";

export const controllers = [
  LoginController,
  TerminalHomeController,
  PersonHomeController,
  AppController,
  DebugController,
  SettingsController,
  ExpenseListController,
  ExpenseDetailController,
  AbsenceListController,
  AbsenceDetailController,
  BookingListController,
  EnterController,
  StartController,
  BookingDetailController,
];

export const services = [
  AuthenticationService,
  ScannerService,
  StorageService,
  EntryQueueService,
  DeviceService,
  TimeEntryDataService,
  VersionService,
  NotificationService,
  CordovaService,
  NavigationService,
  CameraService,
  BookingDataService,
  AbsenceDataService,
  ExpenseDataService,
  TerminalSessionService,
  EmployeeDataService,
  UserService,
  LogoutService,
  PwaInstallService,
];

export const factories = [
  {
    name: 'timeoutHttpIntercept',
    fn: ['$rootScope', '$q', ($rootScope: ng.IRootScopeService, $q: ng.IQService) => {
      return {
        'request': (config) => {
          config.timeout = 60000;
          return config;
        }
      };
    }]
  },
  {
    name: 'unauthorizedHttpIntercept',
    fn: ['$rootScope', '$q', '$state', '$injector', ($rootScope: ng.IRootScopeService, $q: ng.IQService, $state: any, injector: any) => {
      return {
        'responseError': (rejection) => {
          if (rejection.status === 401) {
            const authService: AuthenticationService = injector.get('authentication');
            authService.refreshLoginFromCredentials().catch(()=> {
              $state.go('login');
            });
          }
          return $q.reject(rejection);
        }
      };
    }]
  },
];

export const constants = [
  {name: 'webApiUrl', value: environment.webApiUrl},
];

const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/;

function convertDateStringsToDates(input) {
  // Ignore things that aren't objects.
  if (typeof input !== "object") return input;

  for (const key in input) {
    if (!input.hasOwnProperty(key)) continue;

    const value = input[key];
    // Check for string properties which look like dates.
    if (typeof value === "string" && value.match(dateFormat)) {
      input[key] = new Date(value);
    } else if (typeof value === "object") {
      // Recurse into object
      convertDateStringsToDates(value);
    }
  }

  return input;
}

export const configs = [
  {
    inlineFn: [
      '$httpProvider', $httpProvider => {
        $httpProvider.defaults.withCredentials = true;
        //initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
          $httpProvider.defaults.headers.get = {};
        }
        $httpProvider.defaults.headers.common['Accept'] = 'application/json+lower, text/plain, * / *';
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/json+lower';
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/json+lower';
        $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
        $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
        $httpProvider.defaults.transformResponse.push(responseData => {
          convertDateStringsToDates(responseData);
          return responseData;
        });
        $httpProvider.interceptors.push('timeoutHttpIntercept');
        $httpProvider.interceptors.push('unauthorizedHttpIntercept');

      },
    ],
  },
  {
    inlineFn: [
      '$requestSenderProvider', ($requestSenderProvider: RequestSenderProvider) => {
        $requestSenderProvider.setUrl(environment.webApiUrl, '$proxy');
      },
    ],
  },
  {
    inlineFn: [
      '$stateProvider', '$urlRouterProvider', ($stateProvider, $urlRouterProvider) => {
        for (const route of routing) {
          $stateProvider
            .state(route.name, {
              url: route.url,
              templateUrl: route.templateUrl,
              parent: route.parent,
              params: route.params
            });
        }

        $urlRouterProvider.otherwise(defaultRoute);
      },
    ],
  },
  {
    inlineFn: [
      '$httpProvider', ($httpProvider: angular.IHttpProvider) => {

        $httpProvider.interceptors.push([StorageService.serviceId, (storageService: StorageService) => {

          return {
            'request': (req) => {
              const token = storageService.getToken();
              if (req && token) {
                req.headers['X-Application-Cookie'] = token;
              }
              return req;
            },
            'response': (resp) => {
              return resp;
            }
          }
        }]);
      },
    ]
  }
];

export const directives = [
  {
    name: 'trDialog',
    factory: DialogDirective,
  },
  {
    name: 'saveDialog',
    factory: SaveDialogDirective,
  },
  {
    name: 'deleteDialog',
    factory: DeleteDialogDirective,
  },
  {
    name: 'confirmDialog',
    factory: ConfirmDialogDirective,
  },
  {
    name: 'waitDialog',
    factory: WaitDialogDirective,
  },
  {
    name: 'timeEntryDialog',
    factory: TimeEntryDialogDirective,
  },
  {
    name: 'settingsDialog',
    factory: SettingsDialogDirective,
  },
  {
    name: 'clock',
    factory: ClockDirective,
  },
  {
    name: 'expenseTypeDialog',
    factory: ExpenseTypeDialogDirective
  }
];

export const filters = [
  {
    name: 'unsafe',
    factory: ['$sce', ($sce) => {
      return $sce.trustAsHtml;
    }],
  }
];
